import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import machineServiceListAction from './machineServiceList.action.json' with { type: 'json' }
import { machineServiceObject } from '../machineServiceObject'

export const machineServiceExpression = expression(machineServiceObject.shape)

const machineServiceListDefinition = defineAction({
  ...machineServiceListAction,

  input: z.object({
    filter: machineServiceExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      serviceDate: 'Data do serviço',
      startTime: 'Início',
      endTime: 'Fim',
      id: 'Identificador',
      code: 'Código',
      residenceId: 'Residência',
      heavyMachineryId: 'Máquina',
      operatorId: 'Operador',
      status: 'Status',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
  }),
  output: z.object({
    items: z.array(machineServiceObject),
    count: z.number(),
  }),
})

export default machineServiceListDefinition
